import { useQuery } from '@apollo/client'
import { chainedDataIndexExtractor } from '@whitecobalt/tungsten/utils/chainedDataIndex'
import { DocumentNode } from 'graphql'
import React, { memo, useEffect, useMemo } from 'react'
import CheckBox, { CheckBoxProps } from '.'

interface CheckBoxGraphProps extends Omit<CheckBoxProps, 'options'> {
    gql: DocumentNode;
    queryKey?: string;
    labelKey?: string;
    valueKey?: string;
    manageOptions?: (item?: any, index?: number) => {
        value: any;
        label?: string;
        labelNode?: React.ReactNode;
    };
    onLoadData?: (data: any) => void;
    variables?: Record<string, any>;
}

const Graph: React.FunctionComponent<CheckBoxGraphProps> = memo(({ gql, queryKey, labelKey, valueKey, manageOptions, onLoadData, variables, ...props}) => {
    const request = useQuery(gql, { fetchPolicy: "no-cache", variables })
    const options = useMemo(() => {
        const data = request.loading || !request.data ? [] 
            : request.data[queryKey as string]?.items?.map((each: any, index: number) => {
                if(typeof manageOptions === 'function') {
                    return manageOptions(each, index)
                }
                return {
                    label: chainedDataIndexExtractor(labelKey!, each),
                    value: chainedDataIndexExtractor(valueKey!, each)
                }
            })

        return data
    }, [request.loading])

    useEffect(() => {
            
        if(!request.loading && onLoadData) {
            onLoadData(request.data[queryKey as string]?.items || [])
        }

    }, [request.loading])

    return (
        <CheckBox 
            loading={request.loading} 
            options={options} 
            {...props} 
            />
    )
})

Graph.defaultProps = {
    queryKey: 'dropdown',
    labelKey: 'label',
    valueKey: 'value',
}

export default Graph
